module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loading', {
    attrs: {
      "is-loading": ""
    }
  }) : [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.stateContent[_vm.state].image
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].headerText) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    domProps: {
      "innerHTML": _vm._s(_vm.stateContent[_vm.state].bodyText)
    }
  }), _vm._v(" "), (_vm.stateContent[_vm.state].footerText) ? _c('strong', {
    staticClass: "footer-text"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].footerText) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.stateContent[_vm.state].nextText) ? _c('p', {
    staticClass: "body-text"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].nextText) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "w-button w-button--blue continue-cta",
    class: {
      'w-button--gray': _vm.isCTALoading
    },
    attrs: {
      "disabled": _vm.isCTALoading,
      "data-identifier": _vm.stateContent[_vm.state].dataIdentifier
    },
    on: {
      "click": _vm.stateContent[_vm.state].ctaAction
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v(_vm._s(_vm.stateContent[_vm.state].ctaText))])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e()])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6513d779","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/EmailValidation/EmailValidation.vue
// module id = 602
// module chunks = 1